export default __webpack_public_path__ + "static/media/check_gray-2.9cce20c6.svg";